import { render, staticRenderFns } from "./yotpo.vue?vue&type=template&id=ad767742"
import script from "./yotpo.vue?vue&type=script&lang=js"
export * from "./yotpo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EducatorPanel: require('/usr/src/app/components/educator/panel.vue').default})
